import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { NotificationDaysSettingsComponent } from "./notification-days-settings/notification-days-settings.component";

@Component({
    selector: "notification-days",
    templateUrl: "./notification-days.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    NotificationDaysSettingsComponent
]
})
export class NotificationDaysComponent {

   
}